export enum Status {
  FetchedAccounts,
  StoredAccounts,
  MatchedAccountProviders,
  MatchedConnectedAccounts,
  AccountsError,
  MatchingError
}

export interface INotification {
  status: Status;
  userId: string;
  error?: string;
}
